import { getDataMapper, mapField, toFiniteNumber } from "@/shared";

const mapDashboardIncome = getDataMapper({
    income: mapField("income", {
        sumTotal: mapField("sum_total", toFiniteNumber),
    }),
    count: mapField("count", Number),
});

export const mapDashboardExpenseType = getDataMapper({
    expenseTypeId: mapField("expense_type_id", Number),
    expenseType: mapField("expense_type", String),
    expenseSum: mapField("expense_sum", toFiniteNumber),
    percent: mapField("percent", Number),
});

export const mapDashboardAttraction = getDataMapper({
    attractionId: mapField("attraction_id", Number),
    attractionTitle: mapField("attraction_title", String),
    countClients: mapField("count_clients", Number),
    percent: mapField("percent", Number),
});

export const mapIncomeRentState = getDataMapper({
    stateId: mapField("state_id", Number),
    stateTitle: mapField("state_title", String),
    sum: mapField("sum", toFiniteNumber),
    count: mapField("count", Number),
});

export const mapInventoryState = getDataMapper({
    stateId: mapField("state_id", Number),
    stateTitle: mapField("state_title", String),
    countInventory: mapField("count_inventory", Number),
});

export const mapIncomeRepairState = getDataMapper({
    stateId: mapField("state_id", Number),
    stateTitle: mapField("state_title", String),
    sum: mapField("sum", toFiniteNumber),
    count: mapField("count", Number),
});

export const mapDashboardMainFromServer = getDataMapper({
    income: mapField("income", {
        sumTotal: mapField("sum_total", toFiniteNumber),
        sumClean: mapField("sum_clean", toFiniteNumber),
    }),
    expense: mapField("expense", toFiniteNumber),
    clientCount: mapField("client_count", {
        all: mapField("all", Number),
        blackList: mapField("black_list", Number),
    }),
    countContracts: mapField("count_contracts", Number),
    incomeSeparately: mapField("income_separately", {
        rent: mapField("rent", mapDashboardIncome),
        stock: mapField("stock", mapDashboardIncome),
        repair: mapField("repair", mapDashboardIncome),
    }),
    middleReceipts: mapField("middle_receipts", {
        full: mapField("full", toFiniteNumber),
        rents: mapField("rent", toFiniteNumber),
        stock: mapField("stock", toFiniteNumber),
        repair: mapField("repair", toFiniteNumber),
    }),
    graph: mapField("graph"),
    expenseTypes: mapField("expense_types", mapDashboardExpenseType),
    attractions: mapField("attractions", mapDashboardAttraction),
    incomeRentStates: mapField("income_rent_states", mapIncomeRentState),
    inventoryStates: mapField("inventory_states", {
        states: mapField("states", mapInventoryState),
        noPointsCount: mapField("no_points_count", Number),
    }),
    incomeRepairStates: mapField("income_repair_states", mapIncomeRepairState),
    sumDebts: mapField("sum_debts", toFiniteNumber),
});
